import axios from 'axios'
import { getHeader, queryBuilder, urlMapper } from '../helpers/utility'

const authGet = ({ url = '', query = {}, params = {} }) => {
  const queryString = queryBuilder(query)
  const mappedUrl = urlMapper(url, params)
  const combinedUrl = `${mappedUrl}${queryString}`
  return axios
    .get(combinedUrl, { headers: getHeader() })
    .catch(error => {
      if (error.response) {
        throw error.response
      } else {
        throw error
      }
    })
    .then(response => {
      return response
    })
}

export default authGet
